import { commonDefaultSettings } from '../commonDefaultSettings';

/**
  @deprecated константа заменена на хук. Например: choiceSettings => useChoiceSettings
*/

export const shortTextSettings = {
  ...commonDefaultSettings,
  label: 'Short Text',
  placeholder: '',
  hint: '',
  fieldID: 'short_text'
};
